import React, { Component } from 'react';
import { Form, Control, Errors } from 'react-redux-form';
import {isRequired/*, required*/} from "../field_validations";
import _ from 'lodash';

class ContentFormGroupsPhases extends Component {
	render() {
		//const { status } = this.props;
		return (
			<div className="columns is-centered">
				<div className="column is-10">
					<Form model="groupsPhases.edit" onSubmit={(values) => this._handleSubmit(values)}>
						<div className="field is-grouped">
							<div className="control is-expanded">
								<label htmlFor="name" className="label">Nombre de grupo</label>
								<Control.text model=".name" id="name" className="input" errors={{isRequired}} validateOn="change"/>
								<Errors model=".name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El nombre es obligatorio'}} />
							</div>

							{/*<div className="control">
								<label htmlFor="status" className="label">Estatus <span className="small has-text-danger">*</span></label>
								<div className="select">
									<Control.select model=".status_id" id="status" className="select" errors={{required}} validateOn="change">
										<option value="" defaultValue>--- Estatus ---</option>
										{_.map(status.data,(stat, k) => {
											return <option value={stat.id} key={k}>{stat.name}</option>
										})}
									</Control.select>
								</div>
								<Errors model=".status_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
							</div>*/}
						</div>

						<div className="field is-grouped">
							<div className="control">
								<div className="message is-primary">
									<div className="message-body">
										<div className="field">
											<div className="control">
												<label htmlFor="is_registry" className="checkbox">
													<Control.checkbox model=".is_registry" id="is_registry" className="checkbox" isToggle={true}/>
													<span style={{whiteSpace:'normal'}}> Proceso de registro </span>
												</label>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div className="control">
								<div className="message is-primary">
									<div className="message-body">
										<div className="field">
											<div className="control">
												<label htmlFor="is_closing" className="checkbox">
													<Control.checkbox model=".is_closing" id="is_closing" className="checkbox" isToggle={true}/>
													<span style={{whiteSpace:'normal'}}> Proceso de cierre </span>
												</label>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<Control.button model="groupsPhases.edit" className="button is-large" onClick={() => this.props.history.push('/fases/grupos')}>Regresar</Control.button>
							</div>
							<div className="control">
								<Control.button model="groupsPhases.edit" className="button is-primary is-large" type="submit" disabled={this._validateSave()}>Guardar</Control.button>
							</div>
						</div>
					</Form>
				</div>
			</div>
		)
	}

	_handleSubmit(values) {
		this.props.groupPhaseSave(values);
	}

	_validateSave(){
		const {groupsPhases} = this.props;
		let gc = _.find(groupsPhases.permissions, (o) => {return o==='Create'});
		let gu = _.find(groupsPhases.permissions, (o) => {return o==='Update'});

		if(!_.isEmpty(groupsPhases.edit) && groupsPhases.edit.id){
			if(gu){
				return false;
			}else {
				return true;
			}
		}else if(!_.isEmpty(groupsPhases.edit) && _.isEmpty(groupsPhases.edit.id)){
			if(gc){
				return false;
			}else {
				return true;
			}
		}else {
			return true;
		}
	}
}

export default ContentFormGroupsPhases;




// WEBPACK FOOTER //
// ./src/elements/phases/groups.jsx